import { GRAY_JOB_RECEIVE_REQUEST, CREATE_GRAY_JOB_RECEIVE, GET_GRAY_JOB_RECEIVES, UPDATE_GRAY_JOB_RECEIVE, DELETE_GRAY_JOB_RECEIVE,
    GRAY_JOB_RECEIVE_REQUEST_FAILURE } from '../types';

const initialState = {
  grayJobReceives: [],
  loading: false,
  error: null,
};

const grayJobReceiveReducer = (state = initialState, action) => {
  switch (action.type) {
    case GRAY_JOB_RECEIVE_REQUEST: {
      return {
        ...state,
        loading: true,
        error: null
      }
    }
    case GET_GRAY_JOB_RECEIVES: {
      return {
        ...state,
        grayJobReceives: [...action.payload],
        loading: false,
        error: null
      }
    }
    case CREATE_GRAY_JOB_RECEIVE:
      return {
        ...state,
        grayJobReceives: [action.payload, ...state.grayJobReceives],
        loading: false,
        error: null
      };
    case UPDATE_GRAY_JOB_RECEIVE:
      const grayJobReceivesData = state.grayJobReceives.slice(0);
      const uIndex = grayJobReceivesData.findIndex((data) => data.id === action.payload.id);
      grayJobReceivesData.splice(uIndex, 1, { ...action.payload.data });
      return {
        ...state,
        grayJobReceives: [ ...grayJobReceivesData ],
        loading: false,
        error: null
      };
    case DELETE_GRAY_JOB_RECEIVE:
      const grayJobReceives = state.grayJobReceives?.slice(0);
      const index = grayJobReceives.findIndex((data) => data.id === action.id);
      if (index > -1) {
        grayJobReceives.splice(index, 1);
      }
      return {
        ...state,
        grayJobReceives: [...grayJobReceives],
        loading: false,
        error: null
      }
    case GRAY_JOB_RECEIVE_REQUEST_FAILURE: {
      return {
        ...state,
        loading: false,
        error: action.error
      }
    }
    default:
      return state;
  }
};

export default grayJobReceiveReducer;
